var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Chip, Typography } from "@mui/material";
import { colors } from "../../../theme";
function checkIfLabelContainsStatus(label) {
    // Get the first word of the label
    var firstWord = label.split(" ")[0];
    if (firstWord === "In") {
        return "In progress";
    }
    if (firstWord === "Not") {
        return "Not started";
    }
    return firstWord;
}
var StatusChip = function (_a) {
    var label = _a.label, customLabel = _a.customLabel, _b = _a.padding, padding = _b === void 0 ? 1 : _b, icon = _a.icon, width = _a.width;
    var labelToCheck = checkIfLabelContainsStatus(label);
    var color = function () {
        switch (labelToCheck) {
            case "published":
                return colors.success;
            case "pendingReview":
                return colors.info;
            case "draft":
                return colors.info;
            case "scheduled":
                return colors.orange;
            case "started":
                return colors.success;
            case "completed":
                return colors.primary;
            case "cancelled":
                return colors.orange;
            case "rejected":
                return colors.black;
            case "In progress":
                return colors.info;
            case "Completed":
                return colors.success;
            case "Not started":
                return colors.notStarted;
            case "Important":
                return colors.white;
            case "Acknowledged":
                return colors.white;
            case "Resource":
                return colors.black;
            case "error":
                return colors.error;
            default:
                return colors.primary;
        }
    };
    var backgroundColor = function () {
        switch (labelToCheck) {
            case "draft":
                return colors.background.info;
            case "pendingReview":
                return colors.background.info;
            case "published":
                return colors.background.success;
            case "scheduled":
                return colors.background.orange;
            case "started":
                return colors.background.success;
            case "completed":
                return colors.background.primary;
            case "cancelled":
                return colors.background.orange;
            case "rejected":
                return colors.background.errorDarker;
            case "In progress":
                return colors.background.progress;
            case "Completed":
                return colors.background.completed;
            case "Not started":
                return colors.background.notStarted;
            case "Important":
                return colors.primary;
            case "Acknowledged":
                return colors.success;
            case "Resource":
                return colors.background.secondary;
            case "error":
                return colors.background.error;
            default:
                return colors.background.primary;
        }
    };
    return (_jsx(Box, __assign({ p: padding }, { children: _jsx(Chip, { style: { color: color(), backgroundColor: backgroundColor(), width: width }, label: _jsx(Typography, __assign({ variant: "semiBoldH5", fontWeight: 700, textTransform: customLabel ? "none" : "capitalize" }, { children: customLabel ? customLabel : label })), icon: icon && icon }) })));
};
export { StatusChip };
//# sourceMappingURL=data:application/json;base64,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